import Head from 'next/head';
import { useRouter } from 'next/router';

export default function SiteHead({ pagina, allDataHome } : { pagina: any, allDataHome?: any }) {
  const router = useRouter();
  const site = allDataHome?.site;

  const baseUrl = typeof window !== 'undefined' ? window.location.origin : `https://${site?.site}`;
  const canonicalUrl = `${baseUrl}${router.asPath.split('?')[0]}`;

  const activeBanners = allDataHome?.allBanners.filter((item: { ativo: boolean; }) => item.ativo);
  const ogImage = activeBanners?.[0]?.url || site?.url_logo || site?.url_icon;

  const tiposImoveis = allDataHome?.tipos.map((tipo: { nome: string; }) => tipo.nome).join(', ');
  const cidades = allDataHome?.cidades.map((cidade: { nome: string; }) => cidade.nome).join(', ');
  const transacoes = site?.transacoes.join(' e ');

  const nomeEmpresa = site?.Dados?.empresa || 'Imobiliária';

  const defaultTitle =
    site?.titulo || `${nomeEmpresa} - Imóveis em ${cidades}`;

  const defaultDescription =
    site?.meta_description ||
    `Encontre ${tiposImoveis} para ${transacoes} nas regiões de ${cidades}. Atendimento personalizado, documentação 100% online e aprovação rápida. Fale com a ${nomeEmpresa}!`;

  const keywords =
    site?.meta_keywords ||
    `imóveis, imobiliária, ${cidades}, ${transacoes}, ${tiposImoveis}`;

  return (
    <Head>
      <title>{defaultTitle}</title>
      <meta name="description" content={defaultDescription} />
      <meta name="keywords" content={keywords} />

      <meta property="og:title" content={defaultTitle} />
      <meta property="og:description" content={defaultDescription} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content={pagina === 'home' ? 'website' : 'article'} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={defaultTitle} />
      <meta name="twitter:description" content={defaultDescription} />
      <meta name="twitter:image" content={ogImage} />

      {site?.url_icon ? <link rel="icon" href={site.url_icon} /> : null}
      <link rel="dns-prefetch" href="https://fotos.sobressai.com.br" />

      {/* Google Tag Manager, Analytics, Pixel (if available) */}
      {site?.tag_google_head ? (
        <div dangerouslySetInnerHTML={{ __html: site.tag_google_head }} />
      ) : null}

      {site?.pixel_facebook_head ? (
        <div dangerouslySetInnerHTML={{ __html: site.pixel_facebook_head }} />
      ) : null}

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": site?.Dados?.empresa || "",
            "image": site?.url_logo || "",
            "url": baseUrl || "",
            "telephone": site?.Dados?.tel1 || "",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": site?.Dados?.endereco || "",
              "addressLocality": site?.Dados?.cidade || "",
              "addressRegion": site?.Dados?.estado || "",
              "postalCode": site?.Dados?.cep || "",
              "addressCountry": "BR"
            },
            "sameAs": [
              site?.Dados?.facebook || "",
              site?.Dados?.instagram || "",
              site?.Dados?.youtube || "",
            ].filter(Boolean)
          })
        }}
      />
    </Head>
  );
}
